import React from "react";
import Slider from "react-slick";
import InnerImageZoom from "react-inner-image-zoom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import "./GSlider.scss";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        right: "10px",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        left: "10px",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};
const NoneNextArrow = () => {
  return (
    <div
      style={{
        display: "none",
      }}
    />
  );
};

const NonePrevArrow = () => {
  return (
    <div
      style={{
        display: "none",
      }}
    />
  );
};

const GSlider = (props) => {
  const [dragging, setDragging] = React.useState(false);
  const handleBeforeChange = React.useCallback(() => {
    setDragging(true);
  }, [setDragging]);

  const handleAfterChange = React.useCallback(() => {
    setDragging(false);
  }, [setDragging]);

  React.useEffect(() => {}, [dragging]);

  const settings = {
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          nextArrow: <NoneNextArrow />,
          prevArrow: <NonePrevArrow />,
        },
      },
    ],
    customPaging: (i) => {
      return (
        <img
          className="cuBottomImage"
          alt="custom paging"
          src={props.images !== undefined && props.images[i]}
          style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "10px" }}
        />
      );
    },
    // responsive: [
    //     {
    //         breakpoint: 1280,
    //         settings: {
    //             slidesToShow: 3,
    //             slidesToScroll: 3,
    //         },
    //     },
    //     {
    //         breakpoint: 992,
    //         settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 2,
    //         },
    //     },
    //     {
    //         breakpoint: 650,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //         },
    //     },
    // ],
  };

  return (
    <div className="gSlider">
      <Slider {...settings} beforeChange={handleBeforeChange} afterChange={handleAfterChange}>
        {props.images !== undefined &&
          props.images.map((item, index) => {
            return (
              <div key={index} className="cuTopImageFigure">
                <InnerImageZoom
                  width={500}
                  height={500}
                  src={item}
                  zoomSrc={item}
                  moveType="drag"
                  //   fullscreenOnMobile={true}
                  hasSpacer={false}
                />
                {/* <img src={item} className="cuTopImage" /> */}
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default React.memo(GSlider);
